import { ZIndex } from '@opallabs/gem'
import { pluralize } from '@opallabs/lambda'
import { Tooltip } from '@opallabs/lapidary'
import * as styles from '../../styles'
import { UseAddToPlanStateValue } from '../../types'

type StampedMomentsMessageProps = {
  momentStamps: UseAddToPlanStateValue['validation']['momentStamps']
  singleSelection: boolean
}

export const StampedMomentsMessage: React.FC<StampedMomentsMessageProps> = ({
  momentStamps,
  singleSelection,
}) => {
  if (!momentStamps.length) return null

  if (singleSelection) {
    return (
      <div
        css={styles.messageContainer}
        className={styles.classes.messageClass}
      >
        This moment is a stamp, and cannot be added to a plan.
      </div>
    )
  }

  return (
    <div
      css={styles.inlineMessageContainer}
      className={styles.classes.messageClass}
    >
      <Tooltip
        content={momentStamps.map(({ title }) => title).join(', ')}
        zIndex={ZIndex.Shroud.Tooltip}
      >
        <span>
          {momentStamps.length} {pluralize('moment', momentStamps.length)}
        </span>
      </Tooltip>
      &nbsp;selected {momentStamps.length > 1 ? 'are' : 'is'} a stamp and cannot
      be added to a plan.
    </div>
  )
}
